import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { createLogger } from "redux-logger";

// Logger Enable or Disable Option
const ENABLE_REDUX_LOGGER =
  process.env.REACT_APP_ENABLE_REDUX_LOGGER === "true";

const logger = createLogger({
  collapsed: true,
  duration: true,
  timestamp: true,
  predicate: () => ENABLE_REDUX_LOGGER,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: true,
      immutableCheck: true,
    });
    return ENABLE_REDUX_LOGGER ? middleware.concat(logger) : middleware;
  },
  devTools: ENABLE_REDUX_LOGGER,
});

export default store;
